import * as React from 'react';
import { Modal, ModalFooter, ModalTitle, ModalBody, ModalHeader } from '@common/components/modal';
import { Button } from '@common/components/Button';
import { FormControl } from '@common/components/form-control';
import { isEmail } from '@common/utils/email';
import { getEmailConfirmationStatus, confirmEmail } from './actions';

import './EmailConfirmationModal.styles.scss';

export class EmailConfirmationModal extends React.Component {
  state = {
    loading: true,
    needsConfirmation: false,
    hasEmail: false,
    email: '',
    edited: false,
    submitting: false,
  };

  componentDidMount() {
    this.loadStatus();
  }

  loadStatus = async () => {
    try {
      const status = await getEmailConfirmationStatus();
      if (!status.needsConfirmation) {
        this.props.close();
        return;
      }
      this.setState({
        loading: false,
        needsConfirmation: true,
        hasEmail: Boolean(status.email),
        email: status.email || '',
      });
    } catch (e) {
      this.props.close();
    }
  };

  handleEmailChange = (e) => {
    this.setState({ email: e.target.value, edited: true });
  };

  get isEmailValid() {
    return isEmail(this.state.email);
  }

  get errorMessage() {
    const { edited, email } = this.state;
    if (edited && (!email || !this.isEmailValid)) {
      return 'Please enter a valid email address.';
    }
    return null;
  }

  handleSave = async () => {
    this.setState({ edited: true });
    if (!this.isEmailValid) {
      return;
    }
    this.setState({ submitting: true });
    try {
      await confirmEmail(this.state.email.trim());
      this.props.close();
    } catch (e) {
      this.setState({ submitting: false });
    }
  };

  render() {
    const { loading, needsConfirmation, hasEmail, email, submitting } = this.state;

    if (loading || !needsConfirmation) {
      return null;
    }

    const title = hasEmail ? 'Confirm your email address' : 'Add your email address';
    const message = hasEmail ? 'Please confirm or update your email address to continue to use Progeny.' :
        'To continue using Progeny, please provide a valid email address for your account.';
    const buttonLabel = hasEmail ? 'Confirm & Continue' : 'Save';

    return (
      <Modal
        show
        animation={false}
        className="EmailConfirmation"
        backdrop="static"
        bsClass="bootstrap modal"
        dialogClassName="EmailConfirmation"
      >
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
        </ModalHeader>
        <ModalBody className="EmailConfirmation__body">
          <p className="EmailConfirmation__body__message">{message}</p>
          <div className="EmailConfirmation__body__field">
            <label htmlFor="email-confirmation-input">
              <span className="required">*</span>Email
            </label>
            <FormControl
              id="email-confirmation-input"
              type="email"
              value={email}
              onChange={this.handleEmailChange}
              errorMessage={this.errorMessage}
              autoFocus
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            id="btn-email-confirmation-save"
            bsStyle="primary"
            disabled={submitting || !this.isEmailValid}
            onClick={this.handleSave}
          >
            {submitting ? 'Please wait...' : buttonLabel}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}
